import React from 'react'
import useHeaderScroll from '../../../components/header/headerScrollWrap/useHeaderScroll'
import HeaderScrollWrap from '../../../components/header/headerScrollWrap'
import { SwitchPageTabContent, SwitchTabBorder } from '../../../components/switchTab'
import { getTabOption } from '../common'

export default ({ tabValue, onChange, params, root, cardTypeResult, onCardTypeChange }) => {
  const tabOptions = getTabOption()
  const positionY = useHeaderScroll({
    root: () => root
  })

  return <HeaderScrollWrap
    positionY={positionY}
    renderLeftBottom={() => <SwitchPageTabContent
      value={tabValue}
      options={tabOptions}
      onChange={onChange}
    />}
    renderRightBottom={() => <div>
      {
        !!cardTypeResult.current.option.length && <SwitchTabBorder
          allowClear={cardTypeResult.current.allowClear}
          value={params.cardType}
          options={cardTypeResult.current.option}
          onChange={onCardTypeChange}
        />
        }
    </div>}
  />
}
